import { GetProgrammaticCampaignCreativeEngagementTestingRO } from "@intentsify/dto";
import { apiService, Endpoints } from "api";
import { DisplayPerformanceFilters } from "screens";

export const getProgrammaticCampaignEngagementTestingResults = async (
  id: string,
  filters: DisplayPerformanceFilters
): Promise<GetProgrammaticCampaignCreativeEngagementTestingRO> => {
  const { data } = await apiService.get(
    Endpoints.ProgrammaticCampaigns.CreativeEngagement.Get.EngagementTestingResults(
      id
    ),
    {
      params: {
        yearFrom: filters.yearFrom,
        yearTo: filters.yearTo,
        weekFrom: filters.weekFrom,
        weekTo: filters.weekTo,
      },
    }
  );

  return data;
};
